import {Controller} from 'stimulus'

export default class extends Controller {
  switch(event) {
    // Get all buttons within the controller's scope
    const buttons = this.element.querySelectorAll('.btn');

    // Remove the active class and reset to btn-default for all buttons
    buttons.forEach(button => {
      button.classList.remove('btn-primary');
      button.classList.add('btn-default');
    });

    // Add the active class and change to btn-primary for the clicked button
    const currentButton = event.currentTarget;
    currentButton.classList.remove('btn-default');
    currentButton.classList.add('btn-primary');
  }
}
